import { TemplateHeaderPreview } from '../../../components/main/options/model/types'
import newGet from '../../methods/get'

async function previewFile(file: string): Promise<TemplateHeaderPreview> {
    const getApi = await newGet(`${file}/preview`)
    if (getApi.status == 200) {
        const data = (await getApi.json()) as TemplateHeaderPreview
        return data
    }
    return null
}

export { previewFile }
